module.exports = __webpack_public_path__ + "static/img/dayung.904fa9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dayung.jpg
// module id = xb+a
// module chunks = 1